import { GageLogo } from "./GageLogo.tsx";
import IconHistory from "tabler-icons/history.tsx";
import IconSettings from "tabler-icons/settings.tsx";
import IconEdit from "tabler-icons/edit.tsx";
import IconShare from "tabler-icons/share.tsx";
import { useAppData } from "./App.tsx";

export function Header() {
  const appData = useAppData();

  function clear() {
    location.href = appData.siteURL;
  }

  function share() {
    prompt('Copy the link to share', globalThis.location.href);
  }

  function history() {
    const dialog = document.querySelector('dialog.history') as HTMLDialogElement;
    if (!dialog) return;
    dialog.showModal();
  }

  function settings() {
    const dialog = document.querySelector('dialog.settings') as HTMLDialogElement;
    if (!dialog) return;
    dialog.showModal();
  }


  return <header class="header">
    <div class="left">
      {!appData.isStartPage.value ? <a href="/" class="logo"> <GageLogo /> </a> : ''}
    </div>
    <div class="right">
      <span class="title">{appData.chatData.value?.title}</span>
      {!appData.isStartPage.value && <>
        <button onClick={clear}> <IconEdit /> </button>
        <button onClick={share}> <IconShare /> </button>
      </>}
      {appData.user.value && <button onClick={settings}> <IconSettings /> </button>}
      {appData.user.value && <button onClick={history}> <IconHistory /> </button>}
      {/* <button> <IconSettings /> </button> */}
    </div>
  </header>
}